import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import TireconnectSettingsHtml from './tireconnect.settings.html';

export function TireConnectStates (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'TireconnectSettingsCtrl',
    name       : 'app.tireconnect-settings',
    templateUrl: TireconnectSettingsHtml,
    url        : '/tireconnect_settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    }
  });
}
